import { createStructuredSelector } from 'reselect';

import { fetchGAWState } from './LoadingPageSelectors';
import {
  selectAccountID,
  selectAvailableBalance,
  selectCurrentBalance,
} from '../../../../../selectors/globalSelectors';

export const selectCharityName = (state) => {
  const { selectedCharityName } = fetchGAWState(state);
  return selectedCharityName;
};

export const selectCharityAddress = (state) => {
  const { selectedCharityAddress } = fetchGAWState(state);
  return selectedCharityAddress;
};

export const selectCharityEin = (state) => {
  const { selectedCharityEin } = fetchGAWState(state);
  return selectedCharityEin;
};

export const selectPurposeDescription = (state) => {
  const { purpose } = fetchGAWState(state);
  return purpose.description;
};

export const selectAccountData = (state) => {
  const { accountData } = fetchGAWState(state);
  return accountData.data;
};

export const selectPayment = (state) => {
  const { grantAllocation } = fetchGAWState(state);
  if (
    grantAllocation &&
    grantAllocation.paymentComponent &&
    grantAllocation.paymentComponent.payment
  ) {
    return grantAllocation.paymentComponent.payment;
  }
  return [];
};

export const selectAllocationAmount = (state) => {
  const { grantAllocation } = fetchGAWState(state);
  if (
    grantAllocation &&
    grantAllocation.amountAllocation &&
    grantAllocation.amountAllocation.amount
  ) {
    return grantAllocation.amountAllocation.amount;
  }
  return '';
};

export const selectGrantAllocation = (state) => {
  const { grantAllocationSelect } = fetchGAWState(state);
  return grantAllocationSelect;
};

export const selectGrantRecognition = (state) => {
  const { grantRecognition } = fetchGAWState(state);
  if (grantRecognition && grantRecognition.grantRecognition) {
    return grantRecognition.grantRecognition;
  }
  return '';
};

export const selectEdit = (state) => {
  const { edit } = fetchGAWState(state);
  return edit;
};

export const agreementFlowDerivedStates = createStructuredSelector({
  selectedAccountId: selectAccountID,
  availableBalance: selectAvailableBalance,
  currentBalance: selectCurrentBalance,
  selectedCharityName: selectCharityName,
  selectedCharityAddress: selectCharityAddress,
  selectedCharityEin: selectCharityEin,
  grantPurposeName: selectPurposeDescription,
  accountData: selectAccountData,
  payment: selectPayment,
  grantAmount: selectAllocationAmount,
  allocationType: selectGrantAllocation,
  grantRecognitionId: selectGrantRecognition,
  edit: selectEdit,
});
